import { create } from 'zustand'

const currentYear = new Date().getFullYear()

export const useYearRangeStore = create(set => ({
  yearFrom: currentYear - 9,
  yearTo: currentYear,
  setYearFrom: yearFrom => set({ yearFrom }),
  setYearTo: yearTo => set({ yearTo }),
}))
